import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import {
  getAllEmployeeTasks,
  getAllVehicleSlots,
  getgeneralNestedItemdualcondition,
  getgeneralNestedItemdualconditionvehicles,
  getgeneralNestedItemdualconditionvehiclesSupervisor,
  getprojectvehichles,
  getprojectvehichlesforsupervisors,
  saveitem,
  saveuserdata,
  savevehicledata,
  updateItem,
} from "../../utils/firebasefunctions";
import { downloadExcel } from "react-export-table-to-excel";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";
import { ToastContainer, toast } from "react-toastify";
import { GoPlus } from "react-icons/go";
import { RotatingLines } from "react-loader-spinner";
import { FaCar } from "react-icons/fa";
import userlogo from "../images/user.png";
import { FaUser } from "react-icons/fa";
import { actionType } from "../context/reducer";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { storage, app } from "../../firebase.config";
import Reminderpopup from "../components/Reminderpopup";
import CurrentReminders from "../components/CurrentReminders";
import Vehicledropdown from "../components/Vehicledropdown";
import { IoIosCloseCircle } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import moment from "moment";
import VehicleHistory from "../components/VehicleHistory";
import EmployeePopup from "../components/EmployeePopup";
import { arrayUnion } from "firebase/firestore";

function CreateVehichle() {
  const [{ user, employees }, dispatch] = useStateValue();
  const [vehiclenumber, setvehiclenumber] = useState("");
  const [vehicles, setvehicles] = useState([]);
  const [vehiclelist, setvehiclelist] = useState([]);

  const [loader, setloader] = useState(false);
  const [picturedata, setpicturedata] = useState("");
  const [laoding, setloading] = useState(false);
  const [generalreminders, setgeneralreminders] = useState([]);
  const [vehiclehistorydata, setvehiclehistorydata] = useState([]);
  const [vehiclepopup, setvehiclepopup] = useState(false);
  const [startdate, setstartdate] = useState(
    new Date(new Date().setHours(0, 0, 0, 0)),
  );
  const [enddate, setenddate] = useState(
    new Date(new Date().setHours(23, 59, 59, 59)),
  );
  const [employeepopup, setemployeepopup] = useState(false);
  const [reminderpopup, setreminderpopup] = useState(false);
  const [currentreminderpopup, setcurrentreminderpopup] = useState(false);
  const [vehiclehistorypopup, setvehiclehistorypopup] = useState(false);
  const [vehiclereminders, setvehiclereminders] = useState([]);
  const [selectedemployee, setselectedemployee] = useState([]);
  const [reminderassociatedvehicle, setreminderassociatedvehicle] =
    useState("");
  const [picture, setpicture] = useState("");
  const [selectedtype, setselectedtype] = useState("Stats");
  const fileInput = useRef();
  const header = ["Vehicle Number", "Time", "Reminder"];
  useEffect(() => {
    projectvehichles();
  }, []);

  useEffect(() => {
    if (user.usertype == "Supervisor") {
      getgeneralhoursforSupervisor();
    } else {
      getgeneralhours();
    }
  }, [startdate, enddate, vehiclelist]);

  const getgeneralhoursforSupervisor = async () => {
    setloading(true);
    setgeneralreminders([]);

    if (vehicles.find((data) => data.selected == true) == undefined) {
      let dataset = [];
      for (const key in vehiclelist) {
        dataset.push(vehiclelist[key].registrationnumber);
      }
      await getgeneralNestedItemdualconditionvehiclesSupervisor(
        "reminders",
        "remindertimestamp",
        ">=",
        startdate.getTime(),
        "remindertimestamp",
        "<=",
        enddate.getTime(),
        "registrationnumber",
        "in",
        dataset,
      )
        .then(async (response) => {
          setloading(false);
          setgeneralreminders(response);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    } else {
      let dataset = [];
      for (const key in vehiclelist) {
        if (vehiclelist[key].selected == true) {
          dataset.push(vehiclelist[key].registrationnumber);
        }
      }

      await getgeneralNestedItemdualconditionvehicles(
        "reminders",
        "remindertimestamp",
        ">=",
        startdate.getTime(),
        "remindertimestamp",
        "<=",
        enddate.getTime(),
        "registrationnumber",
        "in",
        dataset,
        false,
      )
        .then(async (response) => {
          setloading(false);
          setgeneralreminders(response);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    }
  };
  const getgeneralhours = async () => {
    setloading(true);
    setgeneralreminders([]);

    if (vehicles.find((data) => data.selected == true) == undefined) {
      await getgeneralNestedItemdualconditionvehicles(
        "reminders",
        "remindertimestamp",
        ">=",
        startdate.getTime(),
        "remindertimestamp",
        "<=",
        enddate.getTime(),
        "createdby",
        "==",
        user.usertype == "Supervisor" ? user.createdby : user.id,
        true,
      )
        .then(async (response) => {
          setloading(false);
          setgeneralreminders(response);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    } else {
      let dataset = [];
      for (const key in vehiclelist) {
        if (vehiclelist[key].selected == true) {
          dataset.push(vehiclelist[key].registrationnumber);
        }
      }

      await getgeneralNestedItemdualconditionvehicles(
        "reminders",
        "remindertimestamp",
        ">=",
        startdate.getTime(),
        "remindertimestamp",
        "<=",
        enddate.getTime(),
        "registrationnumber",
        "in",
        dataset,
        false,
      )
        .then(async (response) => {
          setloading(false);
          setgeneralreminders(response);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    }
  };

  const projectvehichles = async () => {
    if (user.usertype == "Supervisor") {
      await getprojectvehichlesforsupervisors("vehicles", user.id)
        .then(async (response) => {
          if (response.length > 0) {
            setvehicles(response);
            setvehiclelist(response);
          }
        })
        .catch((err) => {
          alert(err);
        });
    } else {
      await getprojectvehichles("vehicles", user.id)
        .then(async (response) => {
          if (response.length > 0) {
            setvehicles(response);
            setvehiclelist(response);
          }
        })
        .catch((err) => {
          alert(err);
        });
    }
  };

  const handletaskChange = (event) => {
    setvehiclenumber(event.target.value);
  };

  const addasset = async () => {
    let selectedemployeelist = selectedemployee
      .filter((emp) => emp.selected) // Keep only selected ones
      .map((emp) => emp.id);

    if (vehiclenumber == "") {
      toast.warn("Please fill out a vehicle number");
    } else {
      setloader(true);

      if (picturedata != "") {
        const imageFile = picturedata.target.files[0];
        const storageRef = ref(
          storage,
          `vehiclepicture/${Date.now()}-${imageFile.name}`,
        );
        const uploadTask = uploadBytesResumable(storageRef, imageFile);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            //   const uploadProgress = (snapshot.bytesTransferred/snapshot.totalBytes)*100
          },
          (error) => {
            setloader(false);
            toast.error("upload error " + error.message);
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref)
              .then(async (downloadURL) => {
                let data = {
                  id: Date.now(),
                  creationdate: Date.now(),
                  logo: downloadURL,
                  registrationnumber: vehiclenumber,
                  createdby:
                    user.usertype == "Supervisor" ? user.createdby : user.id,
                  assignedsupervisors: selectedemployeelist,
                };

                await savevehicledata(data, data.id)
                  .then(async (response) => {
                    if (response == "success") {
                      toast.success("Vehicle Created Successfully");
                      if (selectedemployeelist.length > 0) {
                        for (const key in selectedemployeelist) {
                          let datavehicles = {
                            vehiclesassigned: arrayUnion(data.id),
                          };

                          await updateItem(
                            "users",
                            selectedemployeelist[key],
                            datavehicles,
                          )
                            .then((response) => {
                              if (key == selectedemployeelist.length - 1) {
                                setselectedemployee([]);
                                let employeesdata = [...employees];
                                for (const key in employeesdata) {
                                  employeesdata[key].selected = false;
                                }

                                dispatch({
                                  type: actionType.STORE_EMPLOYEES,
                                  payload: employeesdata,
                                });
                              }
                            })
                            .catch((err) => {
                              alert("update employee error " + err);
                              setloader(false);
                            });
                        }
                      }
                      setvehiclenumber("");
                      setpicture("");
                      setpicturedata("");
                    } else {
                      toast.error(
                        "Something went wrong while posting your task. Please try again later.",
                      );
                    }

                    setloader(false);
                  })
                  .catch((err) => {
                    alert(err);
                    setloader(false);
                  });
              })
              .catch((error) => {
                setloader(false);
                toast.error(error.message);
              });
          },
        );
      } else {
        let data = {
          id: Date.now(),
          creationdate: Date.now(),
          logo: "",
          registrationnumber: vehiclenumber,
          createdby: user.usertype == "Supervisor" ? user.createdby : user.id,
          assignedsupervisors: selectedemployeelist,
        };

        await savevehicledata(data, data.id)
          .then(async (response) => {
            if (response == "success") {
              toast.success("Vehicle Created Successfully");

              if (selectedemployeelist.length > 0) {
                for (const key in selectedemployeelist) {
                  let datavehicles = {
                    vehiclesassigned: arrayUnion(data.id),
                  };

                  await updateItem(
                    "users",
                    selectedemployeelist[key],
                    datavehicles,
                  )
                    .then((response) => {
                      if (key == selectedemployeelist.length - 1) {
                        setselectedemployee([]);
                        let employeesdata = [...employees];
                        for (const key in employeesdata) {
                          employeesdata[key].selected = false;
                        }

                        dispatch({
                          type: actionType.STORE_EMPLOYEES,
                          payload: employeesdata,
                        });
                      }
                    })
                    .catch((err) => {
                      alert("update employee error " + err);
                      setloader(false);
                    });
                }
              }
              setvehiclenumber("");
              setpicture("");
              setpicturedata("");
            } else {
              toast.error(
                "Something went wrong while posting your task. Please try again later.",
              );
            }

            setloader(false);
          })
          .catch((err) => {
            alert(err);
            setloader(false);
          });
      }
    }
  };

  const handleimageChange = (event) => {
    fileInput.current.click();
  };

  const handleimageselected = (e) => {
    setpicturedata(e);
    setpicture(URL.createObjectURL(e.target.files[0]));
  };

  const handleDownloadExcelGeneral = () => {
    let newdata = [];
    let newgeneralemployeecheckindata = [...generalreminders];
    newgeneralemployeecheckindata.map((val, id) => {
      newdata.push([
        val?.registrationnumber,
        moment(val.remindertimestamp).format("YYYY-MM-DD hh:mm"),
        val.remindernote,
      ]);
    });

    downloadExcel({
      fileName: "Reminder Sheet",
      sheet: "Reminder-Sheet",
      tablePayload: {
        header,
        body: newdata,
      },
    });
  };

  return (
    <div className="w-[100%] flex flex-col items-center  mt-[70px] md:mt-[0px] ">
      <p className="text-[22px] text-textcolor PoppinsRegular  self-start pb-[30px]">
        Vehicle
      </p>
      <div className=" flex flex-row w-full   ">
        <button
          onClick={() => {
            setselectedtype("Stats");
          }}
          type="submit"
          className={` drop-shadow-lg  text-center py-2 rounded-md ${
            selectedtype == "Stats"
              ? "bg-themeblue hover:bg-themeblue/80 text-textcolor"
              : "bg-themelightblack hover:bg-themeblue/80 text-textcolor"
          } px-[10px]   text-sm  PoppinsRegular uppercase`}
        >
          Stats
        </button>
        {(user.usertype == "Supervisor" && user.vehiclecreationrole) ||
        user.usertype == "Admin" ||
        user.usertype == "SuperAdmin" ? (
          <button
            onClick={() => {
              setselectedtype("Create Vehicle");
            }}
            type="submit"
            className={`text-center py-2 rounded-md ml-[5px] ${
              selectedtype == "Create Vehicle"
                ? "bg-themeblue hover:bg-themeblue/80 text-textcolor"
                : " bg-themelightblack hover:bg-themeblue/80 text-textcolor"
            } px-[10px]  text-sm  PoppinsRegular uppercase   drop-shadow-lg`}
          >
            Create Vehicle
          </button>
        ) : null}
      </div>
      <div className=" bg-themelightblack w-[100%]   py-[30px]  mx-auto  bg-cardOverlay rounded-xl  drop-shadow-lg mt-[10px] ">
        {selectedtype == "Create Vehicle" && (
          <div className="px-[20px]">
            <div className="w-full flex flex-col justify-center">
              <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                Vehicle Image
              </p>
              <div className="flex justify-center my-[10px] items-center relative mt-5 lg:mt-0 bg-cardOverlay  drop-shadow-lg w-full rounded-lg overflow-hidden  h-[400px] border border-bordercolor">
                {picture ? (
                  <div className="w-[100%] h-[100%] ">
                    <button
                      onClick={() => {
                        setpicture("");
                        setpicturedata("");
                      }}
                      type="submit"
                      className="position absolute top-[0px] right-[15px] text-center py-2 rounded-2xl mt-6 bg-red-500 hover:bg-red-500/80 px-[10px]  mx-auto text-textcolor text-sm  PoppinsRegular uppercase"
                    >
                      Remove
                    </button>
                    <img
                      loading="lazy"
                      src={picture}
                      className="w-[100%] h-[100%] object-cover   "
                    />
                  </div>
                ) : (
                  <div className="w-[100%] h-[100%] bg-themelightblack flex justify-center items-center ">
                    <div
                      onClick={handleimageChange}
                      className=" bg-themeColor w-[100px] h-[100px] flex justify-center items-center rounded-full  cursor-pointer"
                    >
                      <GoPlus className="text-textcolor w-[50px] h-[50px]" />
                    </div>
                  </div>
                )}
                <input
                  type="file"
                  style={{ display: "none" }}
                  ref={fileInput}
                  onChange={handleimageselected}
                />
              </div>
            </div>

            <div className="w-full mt-[10px] ">
              <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                Vehicle Number
              </p>
              <input
                type="text"
                value={vehiclenumber}
                placeholder="Enter Vehicle Number eg: ABC-123"
                onChange={handletaskChange}
                className="input px-4 text-black text-sm  PoppinsRegular w-full py-[10px] rounded-md border border-bordercolor items-center flex bg-white"
              />
            </div>
          </div>
        )}
        {selectedtype == "Stats" && (
          <div className=" overflow-x-auto    bg-cardOverlay rounded-xl  drop-shadow-lg overflow-y-scroll m-h-[45%]">
            <table className="min-w-full divide-y divide-bordercolor bg-themelightblack text-sm">
              <thead className="ltr:text-left rtl:text-right">
                <tr>
                  <th className="whitespace-nowrap py-2  px-4  PoppinsRegular text-textcolor"></th>
                  <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                    Vehicle Number
                  </th>
                  <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                    Mileage
                  </th>
                  <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor"></th>
                </tr>
              </thead>

              <tbody className=" text-center">
                {vehicles &&
                  vehicles.map((item, index) => (
                    <tr
                      key={index.toString()}
                      className="hover:bg-[#0989B826]/10 cursor-pointer"
                      onClick={() => {}}
                    >
                      <td className="whitespace-nowrap w-[100px] py-2 flex justify-center  PoppinsRegular text-textcolor">
                        {item.logo != "" ? (
                          <img
                            loading="lazy"
                            src={item.logo}
                            className="w-[30px] h-[30px] lg:w-[40px] lg:h-[40px] rounded-full"
                          />
                        ) : (
                          <div className="w-[30px] h-[30px] lg:w-[40px] lg:h-[40px] rounded-full   drop-shadow-lg  flex justify-center items-center">
                            <FaCar className="w-[25px] h-[25px] lg:w-[35px] lg:h-[35px] text-textcolor" />
                          </div>
                        )}
                      </td>
                      <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor">
                        {item?.registrationnumber}
                      </td>
                      <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor">
                        {item?.mileage || 0} KM
                      </td>
                      <td className="pr-[15px] md:pr-[0px]">
                        <div className="flex flex-row  justify-end pr-[20px]">
                          <button
                            onClick={() => {
                              setreminderassociatedvehicle(item);
                              setreminderpopup(true);
                            }}
                            type="submit"
                            className="text-center w-[105px] py-[5px] rounded-md bg-themeblue text-textcolor text-sm PoppinsRegular uppercase  "
                          >
                            SET REMINDER
                          </button>
                          <button
                            onClick={async () => {
                              await getAllEmployeeTasks(
                                "reminders",
                                "registrationnumber",
                                "==",
                                item.registrationnumber,
                              )
                                .then(async (response) => {
                                  setvehiclereminders(response);
                                  setcurrentreminderpopup(true);
                                })
                                .catch((err) => {
                                  alert(err);
                                });
                            }}
                            type="submit"
                            className="ml-[10px] text-center w-[125px] py-[5px] rounded-md bg-themeblue text-textcolor text-sm PoppinsRegular uppercase  "
                          >
                            VIEW REMINDER's
                          </button>
                          <button
                            onClick={async () => {
                              await getAllVehicleSlots(
                                "slots",
                                "assignedvehicle",
                                "==",
                                item.id,
                              )
                                .then(async (response) => {
                                  let dataobj = [...response];
                                  for (const key in dataobj) {
                                    dataobj[key]["workerstatus"] = dataobj[key]
                                      ?.checkoutdatetime
                                      ? "Checked Out"
                                      : dataobj[key]?.checkindatetime
                                        ? "Checked In"
                                        : dataobj[key]?.onthewaytime
                                          ? "On The Way"
                                          : "Pending";
                                  }
                                  setvehiclehistorydata(dataobj);
                                  setvehiclehistorypopup(true);
                                })
                                .catch((err) => {
                                  console.log(err);
                                  alert(err);
                                });
                            }}
                            type="submit"
                            className="ml-[10px] text-center w-[125px] py-[5px] rounded-md bg-themeblue text-textcolor text-sm PoppinsRegular uppercase  "
                          >
                            VEHICLE HISTORY
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {selectedtype == "Create Vehicle" && (
        <div className=" bg-themelightblack w-[100%]  px-[20px] py-[30px]   mx-auto  bg-cardOverlay rounded-xl  drop-shadow-lg mt-[10px] ">
          <div className="w-full  ">
            <div className=" w-full flex flex-col items-center ">
              {employees.filter((x) => x.selected).length > 0 ? (
                <div className="flex flex-row">
                  {employees
                    .filter((x) => x.selected)
                    .map((item, ind) => {
                      return (
                        <img
                          loading="lazy"
                          style={{
                            marginLeft:
                              employees.filter((x) => x.selected).length > 1
                                ? -50
                                : 0,
                          }}
                          src={
                            item.profilepicture ? item.profilepicture : userlogo
                          }
                          className="w-[100px] h-[100px] rounded-full object-cover"
                        />
                      );
                    })}
                </div>
              ) : (
                <div className="w-[100px] h-[100px] rounded-full  flex justify-center items-center bg-themelightblack bg-cardOverlay drop-shadow-lg ">
                  <FaUser className="w-[50px] h-[50px] text-themeColor" />
                </div>
              )}
              <p className="PoppinsRegular text-textcolor text-sm  pb-1 w-full text-left mt-[20px]">
                Select Supervisor
              </p>

              <div className="flex relative  w-full">
                <div
                  onClick={() => {
                    setemployeepopup(!employeepopup);
                  }}
                  className="px-4 text-textcolor text-sm  PoppinsRegular w-full py-[10px] rounded-md border border-bordercolor items-center flex flex-wrap "
                >
                  {employees?.length == 0 ||
                  employees.find((data) => data.selected == true) == undefined
                    ? "Select Supervisor"
                    : employees
                        .filter(function (data) {
                          return data.selected == true;
                        })
                        .map(function (data) {
                          return (
                            <div
                              onClick={() => {
                                let dataset = [...employees];
                                const designationindex = dataset.findIndex(
                                  (item) => item.id === data.id,
                                );
                                dataset[designationindex].selected = false;
                                dispatch({
                                  type: actionType.STORE_EMPLOYEES,
                                  payload: dataset,
                                });
                              }}
                              className="bg-themeColor px-[5px] py-[1px] mr-[5px] rounded-md flex flex-row items-center mb-[2px]"
                            >
                              <p className="text-textcolor ">
                                {data.firstname}
                              </p>
                              <IoIosCloseCircle
                                onClick={(id) => {
                                  console.log(id);
                                }}
                                className=" text-red-500 ml-[3px]  w-[15px] h-[15px] hover:cursor-pointer"
                              />
                            </div>
                          );
                        })}
                </div>
                <EmployeePopup
                  bulkaction={(status) => {
                    let data = [...employees];
                    // Update the main 'employees' array to mark the selected ones
                    const updatedArray = data.map((item) => ({
                      ...item,
                      selected: item.usertype != "Supervisor" ? false : status,
                    }));
                    dispatch({
                      type: actionType.STORE_EMPLOYEES,
                      payload: updatedArray,
                    });
                    setselectedemployee(
                      updatedArray.filter((obj) => obj.selected),
                    );
                  }}
                  supervisorflow={true}
                  multi={true}
                  visible={employeepopup}
                  data={employees.filter(function (data) {
                    return data.usertype == "Supervisor";
                  })}
                  activateoutsidecontainerclick={() => {
                    setemployeepopup(false);
                  }}
                  onClick={(item, index) => {
                    const employeeindex = employees.findIndex(
                      (itemdata) => item.id === itemdata.id,
                    );

                    let data = [...employees];
                    data[employeeindex].selected =
                      !data[employeeindex].selected;

                    dispatch({
                      type: actionType.STORE_EMPLOYEES,
                      payload: data,
                    });
                    setselectedemployee(data.filter((obj) => obj.selected));
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedtype == "Create Vehicle" &&
        (loader ? (
          <div className=" py-4  mt-6 w-full flex justify-center mb-[40px] ">
            <RotatingLines
              visible={true}
              height="25"
              width="25"
              color="grey"
              strokeColor="#00C763"
              strokeWidth="5"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        ) : (
          <button
            onClick={() => {
              addasset();
            }}
            type="submit"
            className="text-center py-4 rounded-xl mt-6 bg-themeblue hover:bg-themeblue/80 w-full  mx-auto text-textcolor text-sm  PoppinsRegular uppercase mb-[40px]"
          >
            Add Asset
          </button>
        ))}
      {selectedtype == "Stats" && (
        <div className=" w-[100%]  py-[30px]   mx-auto   rounded-xl   mt-[10px] ">
          {generalreminders?.length > 0 && (
            <div className="flex flex-row w-full justify-end items-end py-[10px]">
              <button
                onClick={() => handleDownloadExcelGeneral()}
                type="submit"
                className="text-center px-[10px] py-[5px] rounded-md  bg-themeblue text-textcolor text-sm PoppinsRegular uppercase  "
              >
                Export
              </button>
            </div>
          )}

          <div className="w-full mx-auto flex flex-row flex-wrap justify-between items-center">
            <div className="w-full lg:w-[24%] mt-4 lg:mt-0 ">
              <p className="PoppinsRegular  text-textcolor/80 text-sm pb-1">
                Select Vehicle
              </p>
              <div className="flex relative  w-full">
                <div
                  onClick={() => {
                    setvehiclepopup(!vehiclepopup);
                  }}
                  className="px-4 text-textcolor text-sm  PoppinsRegular w-full py-[10px] rounded-xl  items-center flex flex-wrap bg-themelightblack drop-shadow-lg  "
                >
                  {vehiclelist?.length == 0 ||
                  vehiclelist.find((data) => data.selected == true) == undefined
                    ? "Select Vehicle"
                    : vehiclelist
                        .filter(function (data) {
                          return data.selected == true;
                        })
                        .map(function (data) {
                          return (
                            <div
                              onClick={() => {
                                let dataset = [...vehicles];
                                const designationindex = dataset.findIndex(
                                  (item) => item.id === data.id,
                                );
                                dataset[designationindex].selected = false;
                                setvehiclelist(dataset);
                              }}
                              className="bg-themeColor px-[5px] py-[1px] mr-[5px] rounded-md flex flex-row items-center mb-[2px]"
                            >
                              <p className="text-textcolor ">
                                {data.registrationnumber}
                              </p>
                              <IoIosCloseCircle
                                onClick={(id) => {
                                  console.log(id);
                                }}
                                className=" text-red-500 ml-[3px]  w-[15px] h-[15px] hover:cursor-pointer"
                              />
                            </div>
                          );
                        })}
                </div>
                <Vehicledropdown
                  bulkaction={(status) => {
                    let data = [...vehiclelist];
                    // Update the main 'employees' array to mark the selected ones
                    const updatedArray = data.map((item) => ({
                      ...item,
                      selected: status,
                    }));
                    setvehiclelist(updatedArray);
                  }}
                  multi={true}
                  visible={vehiclepopup}
                  data={vehiclelist}
                  activateoutsidecontainerclick={() => {
                    setvehiclepopup(false);
                  }}
                  onClick={(item, index) => {
                    let data = [...vehiclelist];
                    data[index].selected = !data[index].selected;
                    setvehiclelist(data);
                  }}
                />
              </div>
            </div>

            <div className="w-full lg:w-[24%] mt-4 lg:mt-0">
              <p className="PoppinsRegular  text-textcolor/80 text-sm pb-1">
                From
              </p>
              <DatePicker
                className="input PoppinsRegular  border border-bordercolor rounded-xl w-full  text-textcolor bg-themelightblack drop-shadow-lg  border-none"
                selected={startdate}
                onChange={(date) =>
                  setstartdate(new Date(date.setHours(0, 0, 0, 0)))
                }
              />
            </div>
            <div className="w-full lg:w-[24%] mt-4 lg:mt-0">
              <p className="PoppinsRegular  text-textcolor/80 text-sm pb-1">
                To
              </p>
              <DatePicker
                className="input PoppinsRegular  border border-bordercolor rounded-xl w-full   text-textcolor bg-themelightblack drop-shadow-lg  border-none"
                selected={enddate}
                onChange={(date) =>
                  setenddate(new Date(date.setHours(23, 59, 59, 59)))
                }
              />
            </div>
          </div>

          <div className=" overflow-x-auto   mt-5   rounded-xl  drop-shadow-lg overflow-y-scroll m-h-[45%]">
            {laoding ? (
              <div className=" py-4  mt-6 w-full flex justify-center  ">
                <RotatingLines
                  visible={true}
                  height="25"
                  width="25"
                  color="grey"
                  strokeColor="#00C763"
                  strokeWidth="5"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : (
              <table className="min-w-full divide-y divide-bordercolor bg-themelightblack text-sm ">
                <thead className="ltr:text-left rtl:text-right">
                  <tr>
                    {/* <th className="whitespace-nowrap py-2 px-2  PoppinsRegular text-textcolor"></th> */}
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Vehicle Number
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Time
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor "></th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor text-left">
                      Reminder
                    </th>
                  </tr>
                </thead>

                <tbody className=" text-center">
                  {generalreminders &&
                    generalreminders.map(
                      (item, index) =>
                        !item.delete && (
                          <tr
                            key={index.toString()}
                            className="hover:bg-[#0989B826]/10 cursor-pointer h-[50px]"
                            onClick={() => {}}
                          >
                            {/* <td className="whitespace-nowrap px-2 py-2 PoppinsRegular  ">
                            <MdDelete
                              onClick={() => {
                                // deletereminder(item.id, index);
                              }}
                              className=" text-lighttextGray hover:text-themeColor   w-[20px] h-[20px] hover:cursor-pointer ml-[10px]"
                            />
                          </td> */}
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor pr-[20px]">
                              {item.registrationnumber}
                            </td>
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor pr-[20px]">
                              {moment(item.remindertimestamp).format(
                                "YYYY-MM-DD hh:mm",
                              )}
                            </td>
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor ">
                              <div className="flex flex-row w-[150px] ">
                                {employees
                                  .filter(
                                    (x) =>
                                      item.employeelist.find(
                                        (item) => item == x.id,
                                      ) != undefined,
                                  )
                                  .map((itemdata, ind) => {
                                    return (
                                      <img
                                        loading="lazy"
                                        style={{
                                          marginLeft: 5,
                                          //   marginLeft:
                                          //     employees.filter(
                                          //       (x) =>
                                          //         item.employeelist.find(
                                          //           (item) => item == x.id
                                          //         ) != undefined
                                          //     ).length > 1
                                          //       ? -50
                                          //       : 0,
                                        }}
                                        src={
                                          itemdata.profilepicture
                                            ? itemdata.profilepicture
                                            : userlogo
                                        }
                                        className="w-[35px] h-[35px] rounded-full object-cover"
                                      />
                                    );
                                  })}
                              </div>
                            </td>
                            <td className="whitespace-nowrap pl-4 py-2 PoppinsRegular  text-textcolor text-left pr-[20px]">
                              {item.remindernote}
                            </td>
                          </tr>
                        ),
                    )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      <Reminderpopup
        visible={reminderpopup}
        data={reminderassociatedvehicle}
        activateoutsidecontainerclick={() => {
          setreminderpopup(false);
        }}
        onapprovalsuccess={(id, bool) => {}}
      />

      <CurrentReminders
        visible={currentreminderpopup}
        data={vehiclereminders}
        activateoutsidecontainerclick={() => {
          setcurrentreminderpopup(false);
        }}
        onapprovalsuccess={(id, bool) => {}}
        updatereminders={(data) => {
          setvehiclereminders(data);
        }}
      />

      <VehicleHistory
        visible={vehiclehistorypopup}
        data={vehiclehistorydata}
        activateoutsidecontainerclick={() => {
          setvehiclehistorypopup(false);
        }}
        refetchlist={async () => {
          await getAllVehicleSlots(
            "slots",
            "assignedvehicle",
            "==",
            vehiclehistorydata[0].assignedvehicle,
          )
            .then(async (response) => {
              setvehiclehistorydata(response);
            })
            .catch((err) => {
              console.log(err);
              alert(err);
            });
        }}
        onapprovalsuccess={(id, bool) => {}}
        updatereminders={(data) => {
          setvehiclehistorydata(data);
        }}
      />
    </div>
  );
}

export default CreateVehichle;
